export const buildApplicationCountCacheKey = ({ hiringTeamId }) => ['applicationCount', hiringTeamId]
